import React, { useMemo } from "react";

import { faPercent } from "@fortawesome/pro-solid-svg-icons";
import { faHashtag } from "@fortawesome/pro-solid-svg-icons/faHashtag";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Space from "antd/es/space";
import { useIntl } from "react-intl";

import NumberFormatType from "@mapmycustomers/shared/enum/NumberFormatType";
import { Labeled } from "@mapmycustomers/ui";

import RadioGroup from "@app/component/input/RadioGroup";
import { getNumberFormatTypeDisplayName } from "@app/util/ui";

import styles from "./NumberFormatType.module.scss";

interface Props {
  label?: string;
  onChange?: (filterType: NumberFormatType) => void;
  value?: NumberFormatType;
}

const NumberFormat: React.FC<Props> = ({ label, onChange, value }) => {
  const intl = useIntl();

  const options = useMemo(
    () =>
      Object.values(NumberFormatType).map((type) => ({
        label: (
          <span className={styles.radioButton}>
            <FontAwesomeIcon icon={type === NumberFormatType.PERCENTAGE ? faPercent : faHashtag} />
            {getNumberFormatTypeDisplayName(intl, type)}
          </span>
        ),
        value: type,
      })),
    [intl]
  );

  return (
    <Labeled label={label}>
      <Space size="small">
        <RadioGroup<NumberFormatType>
          onChange={onChange}
          options={options}
          optionType="button"
          value={value}
        />
      </Space>
    </Labeled>
  );
};

export default NumberFormat;
